import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  text-align: center;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  width: 100%;
`
